



// shared/ORDER_CONSTANTS.ts
export const ORDER_STATUS = {
  PENDING_PAYMENT: "PENDING_PAYMENT",
  PAID: "PAID",
  CONFIRMED: "CONFIRMED",
  CANCELLED: "CANCELLED",
  FAILED: "FAILED",
  EXPIRED: "EXPIRED",
  REFUNDED: "REFUNDED",
} as const;

export type OrderStatus =
  typeof ORDER_STATUS[keyof typeof ORDER_STATUS];


export const ORDER_STATUSES: Array<{
  id: number;
  label: string;
  value: OrderStatus;
  color: string;
  icon: string;
  icon_src?: string | null;
  is_active: 0 | 1;
}> = [
  {
    id: 1,
    label: "Pending Payment",
    value: ORDER_STATUS.PENDING_PAYMENT,
    color: "bg-yellow-100 text-yellow-800",
    icon: "⏳",
    icon_src: null,
    is_active: 1,
  },
  {
    id: 2,
    label: "Paid",
    value: ORDER_STATUS.PAID,
    color: "bg-blue-100 text-blue-800",
    icon: "💳",
    icon_src: null,
    is_active: 1,
  },
  {
    id: 3,
    label: "Confirmed",
    value: ORDER_STATUS.CONFIRMED,
    color: "bg-green-600 text-white",
    icon: "✅",
    icon_src: null,
    is_active: 1,
  },
  {
    id: 4,
    label: "Cancelled",
    value: ORDER_STATUS.CANCELLED,
    color: "bg-red-100 text-red-800",
    icon: "❌",
    icon_src: null,
    is_active: 1,
  },
  {
    id: 5,
    label: "Failed",
    value: ORDER_STATUS.FAILED,
    color: "bg-red-200 text-red-900",
    icon: "⚠️",
    icon_src: null,
    is_active: 1,
  },
  {
    id: 6,
    label: "Expired",
    value: ORDER_STATUS.EXPIRED,
    color: "bg-gray-200 text-gray-700",
    icon: "⌛",
    icon_src: null,
    is_active: 1,
  },
  {
    id: 7,
    label: "Refunded",
    value: ORDER_STATUS.REFUNDED,
    color: "bg-gray-300 text-gray-800",
    icon: "💸",
    icon_src: null,
    is_active: 1,
  },
];

export function getOrderStatusInfo(statusKey: string) {
  const status = ORDER_STATUSES.find(
    (s) => s.value === statusKey && s.is_active
  );

  // Fallback for unknown status (always return consistent structure)
  if (!status) {
    return {
      id: null,
      value: statusKey,
      label: statusKey,
      color: "bg-gray-100 text-gray-700",
      icon: null,
      icon_src: null,
      is_active: 0,
    };
  }

  return status;
}